<template>
  <header>
    <div class="container topbar title"><h1>{{ title }}</h1></div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: String
  }
}
</script>

<style scoped>
header {
  background-color: #00929F;
  border-bottom-style: solid;
  border-bottom-color: #FDB913;
  border-width: 5px;
  margin-bottom:15px;
}
.title {
  padding: 15px;
  margin-bottom: 15px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 20px;
  color:#FFF;
  font-family:Arial, Helvetica, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue